import React, {Fragment} from 'react';
import { Grid } from '@material-ui/core';
import _ from 'lodash'
import styled from 'styled-components';
import { connect as reduxConnect } from "react-redux";
import { connect, replace } from 'formik';
import { compose} from "redux";
import { hedgeTypes } from 'constants/hedgeTypes';
import {SectionTitle} from './FormSectionComponents';
import {
  SideLabelTextAreaInput,
 } from './FormSectionComponents';

 const StyledGrid = styled(Grid)`
  &&& {
    width:1200px;
  }
`;

const VerticalSpacer = styled.div`
height:30px;
display:block;
`

class OtherSection extends React.Component {
  state ={};

  render(){    
    const {formik, isEditing, ratingsTriggers} = this.props;
    
    return (
      <Fragment>
        <div id="other_section">
          <VerticalSpacer/>
          <SectionTitle id="other_section">Other</SectionTitle>
          <StyledGrid container alignItems="center" direction="column">
            <SideLabelTextAreaInput label="Other" placeholder="Other Details" 
            fieldName="details.other" isDisabled={!isEditing}/>
          </StyledGrid>
        </div>
      </Fragment>
  )};
}

const mapStateToProps = ({  }) => ({
});

export default compose(  
  connect,
  reduxConnect(
    mapStateToProps,
    {
    }
  )
)(OtherSection);
